// Format numbers from API as dollars with 2 decimals
function formatAsDollars(num) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
}

// Format numbers from API as dollars with 3 decimals
function formatAsDollarsSmall(num, dec = 3) {
    // convert prices that are in scientific notation exemple - 1.97490793e-12
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
    }).format(num);
}

// Format numbers from API as euros with 3 decimals
function formatAsEurosSmall(num, dec = 3) {
    return new Intl.NumberFormat('de-DE', { 
        style: 'currency', 
        currency: 'EUR',
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
    }).format(num);
}

// Format numbers from API as pounds with 3 decimals
function formatAsPoundsSmall(num, dec = 3) {
    return new Intl.NumberFormat('en-GB', { 
        style: 'currency', 
        currency: 'GBP',
        minimumFractionDigits: dec,
        maximumFractionDigits: dec 
    }).format(num);
}

let superscripts = {
    '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄', '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉', '10':'₁₀', 
    '11':'₁₁', '12':'₁₂', '13': '₁₃', '14': '₁₄', '15': '₁₅', '16': '₁₆', '17': '₁₇', '18': '₁₈', '19': '₁₉', '20':'₂₀',
};
const thresholds = [
    { limit: 0.10, decimals: 2 },
    { limit: 0.010, decimals: 3 },
    { limit: 0.0010, decimals: 4 },
    { limit: 0.000100, decimals: 5 }
];

// Format numbers from API as dollars with x decimals
function formatSmallPriceDollar(num) {

    if ( num == '0' ) { return '$0'; }

    num = parseFloat(num);

    if (num >= 0.10) { return formatAsDollarsSmall(num, 2); }
    if (num >= 0.010) { return formatAsDollarsSmall(num, 3); }
    if (num >= 0.0010) { return formatAsDollarsSmall(num, 4); }
    if (num >= 0.000100) { return formatAsDollarsSmall(num, 5); }

    let formatNumD = (num) => {
        for (let { limit, decimals } of thresholds) {
          if (num >= limit) {
            return formatAsDollarsSmall(num, decimals);
          }
        }
    };

    if (num < 0.000100) {     
        
        let numFloat = parseFloat(num);
        // console.group( num, typeof num, numFloat, typeof numFloat );
        let numParts = numFloat.toFixed(20).split('.');
        let decimals = numParts[1];
        let zeroCount = 0;
        while (zeroCount < decimals.length && decimals[zeroCount] === '0') { zeroCount++; }
        let significantPart = decimals.slice(zeroCount, zeroCount + 4); 
        let superscriptZeros = superscripts[zeroCount.toString()];

        return '$0.0' + superscriptZeros + significantPart;
    }    
}




// Format numbers from API as pounds with x decimals
function formatSmallPricePound(num) {

    if ( num == '0' ) { return '£0'; }
    num = num.toString();

    // Check if the input contains 'E' or 'e' (scientific notation)
    if (typeof num === 'string' && (num.includes('E') || num.includes('e'))) {
        num = parseFloat(num).toFixed(20);
    } else {
        num = parseFloat(num);
    }
    num = Number(num);

    if (num >= 0.10) { return formatAsPoundsSmall(num, 2); }
    if (num >= 0.010) { return formatAsPoundsSmall(num, 3); }
    if (num >= 0.0010) { return formatAsPoundsSmall(num, 4); }
    if (num >= 0.000100) { return formatAsPoundsSmall(num, 5); }
    if (num < 0.000100) {

        let numParts = num.toFixed(20).split('.');
        let decimals = numParts[1];
        let zeroCount = 0;
        while (zeroCount < decimals.length && decimals[zeroCount] === '0') { zeroCount++; }
        let significantPart = decimals.slice(zeroCount, zeroCount + 4); 
        let superscriptZeros = superscripts[zeroCount.toString()];

        return '£0.0' + superscriptZeros + significantPart;
    }    
}

// Format numbers from API as BTC or ETH with x decimals
function formatSmallPriceCrypto(num) { 

    if ( num == '0' ) { return '0'; }
    
    num = parseFloat(num);

    if (isNaN(num) || num === 0) {
        return '0.00';  // Return 0.00 for invalid or zero numbers
    }

    let formattedNum;   

    if (num >= 0.10) {
        formattedNum = num.toFixed(2);
    } else if (num >= 0.010) {
        formattedNum = num.toFixed(3);
    } else if (num >= 0.0010) {
        formattedNum = num.toFixed(4);
    } else if (num >= 0.000100) {
        formattedNum = num.toFixed(5);
    } else if ( num < 0.000100 ) {
        let numParts = num.toFixed(20).split('.');
        let decimals = numParts[1];
        let zeroCount = 0;
        // decimals = decimals.toString();     

        while (zeroCount < decimals.length && decimals[zeroCount] == '0') {
            zeroCount++;
        }

        // console.log( 'c',  num );

        console.log( zeroCount, decimals );

        let significantPart = decimals.slice(zeroCount, zeroCount + 4); 
        let superscriptZeros = superscripts[zeroCount.toString()];

        console.log( superscriptZeros );

        formattedNum = '0.0' + superscriptZeros + significantPart; 
    } else {
        formattedNum = '?';
    }

    return formattedNum; 
}



// Format numbers from API as euros with x decimals
function formatSmallPriceEuro(num) {   

    if ( num == '0' ) { return '0 €'; }

    num = num.toString();

    if (typeof num === 'string' && (num.includes('E') || num.includes('e'))) {
        num = parseFloat(num).toFixed(20);
    } else { num = parseFloat(num); }

    num = Number(num);

    // console.log( typeof num, num );

    if (num >= 0.10) { return formatAsEurosSmall(num, 2); }
    if (num >= 0.010) { return formatAsEurosSmall(num, 3); }
    if (num >= 0.0010) { return formatAsEurosSmall(num, 4); }
    if (num >= 0.000100) { return formatAsEurosSmall(num, 5); }
    if (num < 0.000100) {       

        let numParts = num.toFixed(20).split('.');
        let decimals = numParts[1];
        let zeroCount = 0;
        while (zeroCount < decimals.length && decimals[zeroCount] === '0') { zeroCount++; }
        let significantPart = decimals.slice(zeroCount, zeroCount + 4); 
        let superscriptZeros = superscripts[zeroCount.toString()];

        return '0.0' + superscriptZeros + significantPart + ' €';
    }    
}




// Format in EURO
function formatAsEuros(num) {
    return new Intl.NumberFormat('de-DE', { 
        style: 'currency', 
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
}


// Format as pounds
function formatAsPounds(num) {
    return new Intl.NumberFormat('en-GB', { 
        style: 'currency', 
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    }).format(num);
}

// Format number to dollars with zero decimals 
function formatAsDollarsZeroD(num) {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(num);
}

// Format numbers from APi as percentages with 2 decimals (minus is not missing but plus is omitted in results so we need to add +)
function formatAsPercentage(num) {

    let number = parseFloat(num);

    if (isNaN(number)) {
        console.error('Invalid input: expected a number, received NaN' , num);
        return null;
    }

    let formattedNumber = number.toFixed(2);

    if( formattedNumber > 0 ) { return '+' + formattedNumber + '%'; }
    if( formattedNumber < 0 ) { return formattedNumber + '%'; }
    if( formattedNumber == 0 ) { return '0.00%'; }
    return null;    
}

// show only positive value - for cases where arrow shows the correct trend
function formatAsPercentageAbs(num) {
    let number = parseFloat(num);
    if (isNaN(number)) {
        console.error('Invalid input: expected a number, received', num);
        return null;
    }

    let formattedNumber = Math.abs(number).toFixed(2);
    return ' ' + formattedNumber + '%';
}

// generate unique number-letter combo
function ctpGenerateUniqueId() {
    return Math.random().toString(36).slice(2, 10);
}

// encode mask base64
function ctpApplyMask(svgElement) {

    const maskSvg = svgElement;
    const encodedMaskSvg = encodeURIComponent(maskSvg);
    const maskDataUrl = "url('data:image/svg+xml;charset=utf8," + encodedMaskSvg + "')";
  
   return maskDataUrl;
}

// add gradient to svg
function ctpModifySvg(svgElement, positive = true) {
    // Retrieve colors from the localized script settings
    let graphColorP = ctpAjax.graphColorP;  
    let graphColorN = ctpAjax.graphColorN;
    let graphStroke = ctpAjax.graphStroke; 

    const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

    const gradientId = `ctp_${ctpGenerateUniqueId()}`;
    const linearGradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
    linearGradient.setAttribute("id", gradientId);
    linearGradient.setAttribute("x1", "0%");
    linearGradient.setAttribute("y1", "0%");
    linearGradient.setAttribute("x2", "0%");
    linearGradient.setAttribute("y2", "100%");

    const stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    stop1.setAttribute("offset", "20%");
    stop1.setAttribute("stop-opacity", "0.2");
    stop1.setAttribute("stop-color", positive ? graphColorP : graphColorN);

    const stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    stop2.setAttribute("offset", "100%");
    stop2.setAttribute("stop-opacity", "0");
    stop2.setAttribute("stop-color", positive ? graphColorP : graphColorN);

    // Append stops to the gradient
    linearGradient.appendChild(stop1);
    linearGradient.appendChild(stop2);

    // Append <linearGradient> to <defs>
    defs.appendChild(linearGradient);

    // Prepend <defs> as the first child of the SVG
    svgElement.prepend(defs);

    // Update the first <path> element to use the gradient fill
    const pathElement = svgElement.querySelector('path');
    if (pathElement) {
        pathElement.setAttribute("fill", `url(#${gradientId})`);
    }

    // Update the stroke color for the second <path> element
    let path2 = svgElement.querySelector('path:nth-of-type(2)');
    if (path2) {
        path2.setAttribute("stroke", positive ? graphColorP : graphColorN);
        path2.setAttribute("stroke-width", graphStroke );
    }
}






  







